module.exports = __webpack_public_path__ + "media/images/stream_preview_landscape-bd4a4ea9a7fd9f12a4793a8bdaf25f1a.png";